<template>
  <div>
    <div class="out-wrapper">
      <div class="focus-wrapper">
        <span class="focus-title"></span>
        <span class="focus-logo"></span>
        <Nav class="head-nav"></Nav>
      </div>
      <div class="brand-introduce">
        <div class="container">
          <span class="til"></span>
          <p v-for="(item, index) in introduce" :key="index"> {{ item }}</p>
        </div>
        <div class="img-wraper">
          <img v-if="$isMobile"
            src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/C193A5BABCC448EBB9172819408E147A-6-2.jpg"
            width="100%" alt="">
          <img v-else src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_01.jpg" width="100%" alt="">
          <div class="container">
            <span class="en-desc"></span>
            <p class="img-desc">回归本源<br />遵循本味<br />找寻本真</p>
          </div>
        </div>


      </div>
      <div class="brand-story">
        <div class="container">
          <span class="til"></span>
          <span class="yz"></span>
          <p class="story-til">{{ story[0] }}</p>
          <p class="story-1">{{ story[1] }}</p>
          <p class="story-2">{{ story[2] }}</p>
        </div>
        <div class="img-wraper">
          <img v-if="$isMobile"
            src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/66595E12778747A1A39B1FEED0FA88FF-6-2.jpg"
            width="100%" alt="">
          <img v-else src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_02.jpg" width="100%" alt="">
          <div class="container">
            <span class="text-1"><b>熬</b>生活的甜</span>
            <span class="text-2"><b>煮</b>自然的鲜</span>
            <span class="logo-icon"></span>
          </div>
        </div>


      </div>
      <div class="brand-scenes">

        <div class="container">
          <span class="til"></span>
          <div v-for="(item, index) in scenes" :key="index" :class="`p-box ${index === 0 ? 'p-box-1' : ''}`">
            <p class="p-til">{{ item.title }}</p>
            <p>{{ item.paragraph }}</p>
          </div>
        </div>
        <div class="img-wraper">
          <img v-if="$isMobile"
            src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/CB6F84ACF0F44F9396D9EE002477C8DF-6-2.jpg"
            width="100%" alt="">
          <img v-else src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_03.jpg" width="100%" alt="">
          <span class="text">怡满分，<br />
            不仅仅是糖水。<br />
            不缺生活中的<br />
            丝丝甜味，<br />
            但寻甜味本真。</span>
        </div>
      </div>




    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../components/Foot.vue";
import Nav from "../components/Nav.vue";
export default {
  components: {
    Foot,
    Nav
  },
  computed: {
    introduce() {
      return this.$globalData.brand.brand_introuce
    },
    story() {
      return this.$globalData.brand.brand_story
    },
    scenes() {
      return this.$globalData.brand.scenes
    }
  }
}
</script>
<style lang="less" scoped>
@media(max-width: 1200px) {
  .out-wrapper {
    div.container {
      width: 100% !important;
    }

    .brand-introduce {
      .container {
        padding: 7.2vw 0 12vw 0 !important;
        width: 78.6667vw !important;
      }

      .til {
        position: absolute;
        width: 9.6vw !important;
        height: 26.94vw;
        background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/EDB484977EC647D9A4CA4408243CD05E-6-2.png) no-repeat top center;
        background-size: 100% auto;
        right: -0.67vw !important;
        top: 18.1333vw !important;
        margin: 0 !important;
      }

      p {
        font-size: 3.8893vw !important;
        line-height: 4.6667vw !important;
        text-indent: 7.7786vw !important;
        margin: 0 0 5.333vw 0 !important;
        padding: 0;
        width: 55.2vw !important;
      }

      .img-wraper {
        height: auto !important;

        img {
          width: 100% !important;
        }

        .container {
          display: none;
        }
      }
    }

    .brand-story {
      .container {
        height: auto !important;
        width: 78.6667vw !important;
        box-sizing: border-box;
        padding: 26vw 0 0 0 !important;

        .yz {
          width: 21.333vw !important;
          height: 20.5333 !important;
          background-size: 100% auto;
          right: -4.2667vw !important;
          top: 122.133vw !important;
        }

        .til {
          width: 9.06667vw !important;
          height: 25.3333vw !important;
          right: -0.67vw !important;
          top: 48.1333vw !important;
          transform-origin: 0 0;
          background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/4723131240604290A8A8B889144C7389-6-2.png) no-repeat top center;
          background-size: 100% auto;
        }
        p.story-til{
          margin-bottom: 4.2667vw !important;
          padding-top: 12vw !important;
          &::after{
            width: 3.333vw !important;
            left: 7.7786vw !important;
          }
        }

        .story-1,
        .story-2,
        .story-til {
          position: inherit !important;
          top: inherit !important;
          left: inherit !important;
          font-size: 3.8893vw !important;
          line-height: 4.6667vw !important;
          text-indent: 7.7786vw !important;
          margin-bottom: 21.6vw !important;
          width: 55.06778vw !important;
        }
      }

      .img-wraper {


        img {
          width: 100% !important;
        }

        .container {
          display: none;
        }
      }
    }

    .brand-scenes {
      .container {
        height: auto !important;
        width: 78.6667vw !important;
        box-sizing: border-box;
        padding: 14.4vw 0 10.2vw 0 !important;

        .til {
          width: 13.333vw !important;
          height: 52vw !important;
          right: -0.67vw !important;
          top: 24.8vw !important;
          transform-origin: 0 0;
          background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/0DB1B2BA33E343AA8B61413D4F822FFE-6-2.png) no-repeat top center !important;
          background-size: 100% auto !important;
        }

     

        p.p-til {
          text-indent: 0 !important;
        }

        p {
          font-size: 3.8893vw !important;
          line-height: 4.6667vw !important;
          text-indent: 7.7786vw !important;
          margin-bottom: 5.333vw !important;
          width: 55.06778vw !important;
        }
      }

      .img-wraper {
        img {
          width: 100% !important;
        }

        .text {
          right: 50% !important;
          transform: translate(50%, -50%) !important;
          font-size: 10.88vw !important;
          line-height: 11.83vw !important;
          height: 92.88vw !important;
          display: none;
        }
      }
    }
  }
}

@media(max-width: 1560px) {
  .out-wrapper {
    .container {
      width: 1200px !important;
    }
  }

}

.focus-wrapper {
  height: 680px;
  position: relative;

  .head-nav {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.out-wrapper {
  background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/wenli_bg.png") repeat;

  .container {
    width: 1400px;
    margin: 0 auto;
    position: relative;

    p {
      font-size: 38px;
      color: #000000;
      font-family: hanli-min, hanli;
      line-height: 42px;
      text-align: left;
      text-indent: 80px;
      margin: 0 0 40px 0;
    }
  }
}

.brand-introduce {
  .til {
    display: block;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_til_01.png) no-repeat top center;
    width: 252px;
    height: 381px;
    background-size: 100% auto;
    margin: 238px auto 46px auto;
  }



  .img-wraper {
    position: relative;

    .container {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      top: 118px;

      .img-desc {
        position: absolute;
        writing-mode: vertical-rl;
        font-family: hanli-min, hanli;
        font-size: 75px;
        color: #fffbe7;
        left: 0;
        line-height: 110px;
        text-align: end;
      }

      .en-desc {
        position: absolute;
        width: 280px;
        height: 93px;
        background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_text_01.png) no-repeat top center;
        background-size: 100% auto;
        top: 608px;
        left: 10px;
      }
    }
  }

}

.brand-story {
  .container {
    height: 1950px;

    .til {
      position: absolute;
      width: 180px;
      height: 488px;
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_til_02.png) no-repeat top center;
      background-size: 100%;
      top: 388px;
      right: 0;
    }

    p {
      position: absolute;
      width: 662px;
      left: 0;
    }

    .story-til {
      padding-top: 84px;
      top: 400px;

      &::after {
        position: absolute;
        content: "";
        width: 30px;
        height: 2px;
        background: #000;
        left: 88px;
        top: 0;
      }
    }

    .story-1 {
      top: 578px;
    }

    .story-2 {
      top: 1210px;
    }
  }


  .yz {
    position: absolute;
    width: 511px;
    height: 490px;
    background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/CF65A607ECDE4196A3E4D571EB01643C-6-2.png) no-repeat top center;
    background-size: 100%;
    top: 1132px;
    right: -78px;
  }

  .img-wraper {
    position: relative;

    .container {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      top: 0;

      .text-1,
      .text-2 {
        font-size: 78px;
        color: #fef5ee;
        writing-mode: vertical-lr;
        position: absolute;
        line-height: 150px;
        font-family: hanli-min, hanli;

        b {
          font-size: 152px;
          font-weight: normal;
        }
      }

      .text-1 {
        left: 0;
        bottom: 70px;
      }

      .text-2 {
        right: 0;
        top: 85px;
      }

      .logo-icon {
        position: absolute;
        width: 67px;
        height: 66px;
        background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/icon.png) no-repeat top center;
        background-size: 100% auto;
        right: 0;
        bottom: 68px;
      }
    }
  }
}

.brand-scenes {


  p {
    width: 980px;
    font-size: 34px !important;
  }

  .img-wraper {
    position: relative;

    .text {
      position: absolute;
      font-size: 46px;
      color: #ede7da;
      line-height: 50px;
      right: 100px;
      writing-mode: vertical-rl;
      font-family: hanli-min, hanli;
      height: 410px;
      text-align: start;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .container {
    padding: 84px 0;

    .til {
      position: absolute;
      width: 186px;
      height: 662px;
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/brand_til_03.png) no-repeat top center;
      background-size: 100%;
      right: 0;
      top: 160px;
    }

    .p-til {
      text-indent: 0;
      font-size: 34px !important;
    }
  }
}
</style>